import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import TooltipIcon from '../../TooltipIcon';

const computeRate = (num, den) => {
    if (!num) num = 0;
    if (!den) den = 0;
    return parseFloat(den? (num / den * 100).toFixed(1) : 0);
};

const SurveyStatsWidget = ({data, updateSurveyStatsFromWidget}) => {
    // Avoid calling parent state setters during render: schedule update in an effect
    React.useEffect(() => {
        updateSurveyStatsFromWidget(data.completed || 0, data.started || 0);
    }, [data && data.completed, data && data.started, updateSurveyStatsFromWidget]);
    return (
        <div className="d-flex flex-column justify-content-around survey-stats-widget">
            <div className="d-flex stats-container">
                <div className="stats-label"><FormattedMessage {...messages.dashboard.stats.started} /></div>
                <div className="stats-value">{data.started || 0}</div>
            </div>
            <div className="d-flex stats-container">
                <div className="stats-label"><FormattedMessage {...messages.dashboard.stats.completed} /></div>
                <div className="stats-value">{data.completed || 0}</div>
            </div>
            <div className="rates-container">
                <div className="rates-label">
                    <FormattedMessage {...messages.dashboard.stats.completion} />
                    {' '}
                    <TooltipIcon message={messages.dashboard.stats.tooltip.completion} />
                </div>
                <div className="rates-value">{computeRate(data.completed, data.started)}%</div>
            </div>
        </div>
    );
};
export default SurveyStatsWidget;
